import { render } from "./report_input_past.vue?vue&type=template&id=620dd4f0&scoped=true"
import script from "./report_input_past.vue?vue&type=script&scoped=true&lang=js"
export * from "./report_input_past.vue?vue&type=script&scoped=true&lang=js"

import "./report_input_past.vue?vue&type=style&index=0&id=620dd4f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620dd4f0"]])

export default __exports__